import { createSelector } from 'reselect'
import { RootState } from 'redux/store'

const selectNewsAol = createSelector(
  (state: RootState) => state.ca.newsAol,
  (name: string) => name
)

export default selectNewsAol
